module.exports = __webpack_public_path__ + "static/media/permissions.bc8f2326.svg";